import { Logo } from 'common/components/layout';

const Header = (props) => {
  const { step, onMenuClick } = props;
  return (
    <div className="c7-checkout__header">
      <Logo />

      {renderMenu(step, onMenuClick)}
    </div>
  );
};

const renderMenu = (step, onMenuClick) => {
  const customerClick = (e) => {
    e.preventDefault();
    onMenuClick('customer');
  };
  const paymentClick = (e) => {
    e.preventDefault();
    onMenuClick('payment');
  };
  switch (step) {
    case 'customer': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href="/reservation/availability">Reservation Availability</a>
          </div>
          <div className="active">Customer information</div>
          <div>Payment information</div>
        </div>
      );
    }
    case 'payment': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href="/reservation/availability">Reservation Availability</a>
          </div>
          <div>
            <a onClick={customerClick}>Customer information</a>
          </div>
          <div className="active">Payment information</div>
        </div>
      );
    }
    case 'complete': {
      return (
        <div className="c7-checkout-breadcrumbs">
          <div>
            <a href="/reservation/availability">Reservation Availability</a>
          </div>
          <div>
            <a onClick={customerClick}>Customer information</a>
          </div>
          <div>
            <a onClick={paymentClick}>Payment information</a>
          </div>
        </div>
      );
    }
    default:
      throw new Error('Invalid Step');
  }
};

export default Header;
